import { memo } from 'react';
import { useClickEvent, PublisherData, useMethod } from '@roc-digital/ui-lib';
import { Event } from '@roc-digital/mxm-base/types';
import { useParams } from 'react-router-dom';
import { View, Zone } from '@roc-digital/mxm-base/data';
import { useNavigate } from 'react-router';
import { Heading1, ButtonSizes, Button, ButtonVariants, BodyLight, Loading } from '@/components/elements';
import ZonePreview from '@/components/views/Views/ZonePreview';
import { readView } from '@/logic/views';

const PreviewView = memo(() => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const readQuery = useMethod(readView, {
    autoRun: [id || ''],
  })

  const view = readQuery.result;

  const handleBackClick = useClickEvent(() => {
    navigate('/views/');
  });

  const openViewsEvent = useClickEvent(({ data }: Event<PublisherData>) => {
    navigate(('/views/' + data?.id) as string);
  });


  return (
    <div className="flex flex-col w-4/5">
      <div className="flex justify-between h-20 mt-3 mr-10">
        <Heading1 className={'text-2xl text-black'}>Preview: {view?.title}</Heading1>
        <div className={'flex flex-row justify-end w-1/6 gap-3'}>
          <Button
            size={ButtonSizes.medium}
            clickEvent={handleBackClick}
            variant={ButtonVariants.secondary}
            // disabled={loading as boolean}
          >
            <BodyLight className={'font-light'}>Back</BodyLight>
          </Button>
          <Button size={ButtonSizes.medium} clickEvent={openViewsEvent} id={view?.id}>
            <BodyLight className={`${'text-white'} font-light`}>Edit</BodyLight>
          </Button>
        </div>
      </div>
      <div className="flex-grow bg-white p-10 mr-6 rounded">
        {view?.zones
          ?.sort((a, b) => (a.order || 0) - (b.order || 0))
          ?.map((zone, index) => (
            <div key={zone.id}>
              <ZonePreview preview={true} key={index} view={view as View} zone={new Zone(zone)} />
            </div>
          ))}
      </div>
      {readQuery.loading ? <Loading/> : null}
    </div>
  );
});

PreviewView.displayName = 'PreviewView';

export default PreviewView;
